module.exports = __webpack_public_path__ + "static/img/LeveManfred_Tudor-and-others-perform-GeorgeBrecht-CardPiece-for-Voice.289317c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/LeveManfred_Tudor-and-others-perform-GeorgeBrecht-CardPiece-for-Voice.jpg
// module id = I8di
// module chunks = 0